import { render, staticRenderFns } from "./chooseDeptMember.vue?vue&type=template&id=b54b52b6&scoped=true&"
import script from "./chooseDeptMember.vue?vue&type=script&lang=js&"
export * from "./chooseDeptMember.vue?vue&type=script&lang=js&"
import style0 from "./chooseDeptMember.vue?vue&type=style&index=0&id=b54b52b6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54b52b6",
  null
  
)

export default component.exports